import { readingSteps } from "@/mocks/comics";

export default function ReadingGuide() {
  return (
    <section id="guide" className="scroll-mt-28 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1180px] px-4 md:px-6">
        <div className="max-w-[660px]">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">
            <i className="ri-route-line text-sm" aria-hidden="true"></i>
            阅读与下载指南
          </span>
          <h2 className="mt-3 font-heading text-2xl text-foreground-950 md:text-3xl">四步跟上全站进度</h2>
          <p className="mt-2 text-sm leading-relaxed text-foreground-600">
            本站把「找作品、看更新、下全集」串成一条清晰的路径。不管你是只想追一两部连载，还是想把完结作品
            一次收全，都可以按下面的顺序走一遍。
          </p>
        </div>

        <ol className="relative mt-8 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-4">
          {readingSteps.map((step, idx) => (
            <li key={step.step} className="relative rounded-lg border border-background-200 bg-background-100 p-5">
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                  <i className={`${step.icon} text-xl`} aria-hidden="true"></i>
                </span>
                <span className="font-heading text-2xl text-background-300">{step.step}</span>
              </div>
              <h3 className="mt-4 font-heading text-base text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.desc}</p>
              {idx !== readingSteps.length - 1 && (
                <i
                  className="ri-arrow-right-line absolute -right-3 top-1/2 hidden -translate-y-1/2 text-lg text-background-400 lg:block"
                  aria-hidden="true"
                ></i>
              )}
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}